<template>
<div>
    <div class="columns column is-full team-filters">
        <b-field class="column" label="Filter by month">
            <b-select placeholder="Choose a month" v-model="filter.monthQuery">
                <option v-for="option in datesWithMoment" :value="option" :key="option.text">
                    {{ option.text }}
                </option>
            </b-select>
        </b-field>

        <b-field class="column" label="Filter by created/updated">
            <b-select placeholder="Choose a month" v-model="filter.creationOptions">
                <option v-for="option in creationOptions" :value="option" :key="option.text">
                    {{ option.text }}
                </option>
            </b-select>
        </b-field>

        <b-field class="column" label="Filter by student intakes">
            <b-select placeholder="" v-model="filter.intake">
                <option v-for="option in availableIntakes" :value="option" :key="option">
                    {{ option }}
                </option>
            </b-select>
        </b-field>

        <b-field class="column" label="Status">
            <multiselect v-model="filter.status" :options="availableStatus" track-by="value" label="value" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Choose one or more status" :preselect-first="false">
                <template slot="tag" slot-scope="{ option, remove }">
                    <span :class="getRowClass(option.value, false)">
                        <span>{{ option.value }}</span>
                        <span class="multiselect__tag-icon" @click="remove(option)">
                        </span>
                    </span>
                </template>
            </multiselect>
        </b-field>

        <b-field v-if="isManager" class="column" label="Filter by teams">
            <b-select placeholder="Filter by teams" v-model="filter.team">
                <option v-for="option in avaialableTeams" :value="option" :key="option.teamId">
                    {{ option.teamName }}
                </option>
            </b-select>
        </b-field>

        <b-field class="column">
            <b-button @click="resetFilters()">Reset</b-button>
        </b-field>
    </div>
    <b-progress :max="countStatus.total" show-value class="column is-full">
        <template #bar>
            <b-progress-bar :value="countStatus.danger" type="is-danger" show-value>{{ countStatus.danger }} rejected</b-progress-bar>
            <b-progress-bar :value="countStatus.none" type="is-warning" show-value>{{ countStatus.none }} pending</b-progress-bar>
            <b-progress-bar :value="countStatus.success" type="is-success" show-value>{{ countStatus.success }} unconditional</b-progress-bar>
        </template>
    </b-progress>
    <b-message class="message-hide-close" :title="`${countStatus.total} students total`" type="is-warning">
    </b-message>
    <b-collapse class="card show tl__collapse" animation="slide" v-for="(user, index) in team" :key="index" :open="isOpen == index" @open="isOpen = index" :aria-id="'contentIdForA11y5-' + index">
        <template #trigger="props">
            <div class="card-header" role="button" :aria-controls="'contentIdForA11y5-' + index" :aria-expanded="props.open">
                <p class="card-header-title">
                    {{ user.user.username }} - {{ user.user.student_applications.length }} records
                    <b-button @click="setTimeUserSpent(user.userId)">See time spent</b-button>
                </p>
                <a class="card-header-icon">
                    <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
                    </b-icon>
                </a>
            </div>
        </template>
        <div class="content user__content tl__content" v-if="user.user.student_applications.length">
            <div class="student__advisor--card col-lg-4 col-md-6 col-sm-12" v-for="(application, appIndex) in user.user.student_applications" :key="appIndex">
                <router-link :to="{ name: 'edit-student' , params: { id: application.studentId, applicationId: application.id, routeIsEdit: false }}">
                    <user-card class="user__label" :application="application"></user-card>
                </router-link>
            </div>
        </div>
    </b-collapse>

    <TimeChart v-if="selectedUserTime.length" :selectedUserTime="selectedUserTime" @closeAdvisor="setTimeUserSpent(null, [])" />
</div>
</template>

<script>
import TeamService from "../services/team.service.js";
import AdminService from '../services/admin.service';
import UserCard from "./helpers/UserCard.vue";
import {
    datesWithMoment,
    statusOptions,
    statusOptionsClasses
} from '../models/static'
import moment from 'moment';
import UtilService from '../services/util'
import TimeChart from './admin/TimeChart.vue'
import Multiselect from 'vue-multiselect'
export default {
    components: {
        UserCard,
        TimeChart,
        Multiselect
    },
    name: "team-list",
    data() {
        return {
            isOpen: null,
            filter: {
                monthQuery: null,
                intake: null,
                team: null,
                status: null,
                creationOptions: {
                    text: 'Both',
                    value: null,
                }
            },
            creationOptions: [{
                text: 'Both',
                value: null,
            }, {
                text: 'Created at',
                value: true,
            }, {
                text: 'Updated at',
                value: false,
            }],
            team: [],
            teamCopy: [],
            datesWithMoment: [],
            availableIntakes: [],
            availableStatus: [],
            avaialableTeams: [],
            countStatus: {
                danger: 0,
                success: 0,
                none: 0,
                total: 0
            },
            selectedUserTime: []
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isManager() {
            return UtilService.isManager()
        },
    },
    mounted() {
        this.datesWithMoment = datesWithMoment
        this.getTeamLeaderTeams();
    },
    watch: {
        filter: {
            handler() {
                this.changedTeamleaderQuery()
            },
            deep: true
        }
    },
    methods: {
        getTeamLeaderTeams() {
            TeamService.getTeamLeaderTeams({
                id: this.currentUser.id
            }).then((reponse) => {
                this.team = reponse.data.flat(1)
                this.teamCopy = reponse.data.flat(1)
                this.changedTeamleaderQuery()
                this.addFilterOptions()
            })
        },

        resetFilters() {
            this.filter = {
                monthQuery: null,
                intake: null,
                team: null,
                status: null,
                creationOptions: {
                    text: 'Both',
                    value: null,
                }
            }

            this.team = UtilService.deepCopy(this.teamCopy)
        },

        addFilterOptions() {
            const result = [...new Set(this.team.map(user => {
                return user.user.student_applications.map(app => {
                    return !app || !app.student || !app.student.templateOptions ? null : app.student.templateOptions.personalInformation.intake
                })
            }).flat(1).filter(x => x))]

            const avaialableTeams = this.team.map(team => {
                return {
                    teamId: team.teamId,
                    teamName: team.team.name
                }
            })

            this.availableIntakes = result
            const statusList = ['All','None', ...statusOptions]
            this.availableStatus = statusList.map(value => {
                return {
                    value
                }
            })
            
            this.avaialableTeams = [...new Map(avaialableTeams.map(item =>
            [item['teamId'], item])).values()];
        },

        async setTimeUserSpent(id, selectedUserTime) {
            let timeSpent = selectedUserTime

            await AdminService.getUserTimeSpent(id).then(response => {
                timeSpent = response.data.length ? response.data.sort((a, b) => {
                    return new Date(b.updatedAt) - new Date(a.updatedAt)
                }) : []
            })
            this.selectedUserTime = []
            setTimeout(() => {
                this.selectedUserTime = timeSpent
            }, 100);

        },

        countTeamStats() {
            const result = this.team.map(user => {
                return user.user.student_applications.map(app => {
                    return app ? app.status : null
                })
            }).filter(x => x).flat(1)

            const danger = result.filter(res => res === 'Rejected').length
            const success = result.filter(res => res === 'Unconditional' || res === 'Awaiting Uncon' || res === 'Pending').length
            const none = result.length - danger - success

            this.countStatus = {
                danger,
                success,
                none,
                total: result.length
            }
        },

        changedTeamleaderQuery() {
            let teamCopy = UtilService.deepCopy(this.teamCopy)
            if (this.filter.monthQuery) {
                for (let index = 0; index < teamCopy.length; index++) {
                    const element = teamCopy[index];
                    teamCopy[index].user.student_applications = element.user.student_applications.filter(teamApp => this.isCorrectMoment(teamApp))
                }
            }

            if (this.filter.intake) {
                for (let index = 0; index < teamCopy.length; index++) {
                    const element = teamCopy[index];
                    teamCopy[index].user.student_applications = element.user.student_applications.filter(teamApp => this.filterByIntake(teamApp))
                }
            }

            if (this.filter.status) {
                for (let index = 0; index < teamCopy.length; index++) {
                    const element = teamCopy[index];
                    teamCopy[index].user.student_applications = element.user.student_applications.filter(teamApp => this.filterByStatus(teamApp))
                }
            }

            if (this.isManager && this.filter.team && this.filter.team.teamId) {
                teamCopy = teamCopy.filter(team => this.filterByTeam(team))
            }

            this.team = [...teamCopy]
            this.countTeamStats()
        },

        isCorrectMoment(app) {
            if(!app.student) {
                return true
            }

            const recordTime = this.filter.creationOptions !== null ? moment(this.filter.creationOptions ? app.student.createdAt : app.student.updatedAt) : null

            return this.filter.monthQuery ? this.filter.creationOptions === null ?
                this.filter.monthQuery.month === moment(app.student.createdAt).month() && this.filter.monthQuery.year === moment(app.student.createdAt).year() ||
                this.filter.monthQuery.month === moment(app.student.updatedAt).month() && this.filter.monthQuery.year === moment(app.student.updatedAt).year() :
                this.filter.monthQuery.month === recordTime.month() && this.filter.monthQuery.year === recordTime.year() : true
        },

        filterByIntake(teamApp) {
            return teamApp.student && teamApp.student.templateOptions !== null ? teamApp.student.templateOptions.personalInformation.intake === this.filter.intake : true
        },

        filterByStatus(teamApp) {
            return this.filter.status && this.filter.status.length ?
                this.filter.status.some(docFilter => {
                    return docFilter.value === 'All' ? true : docFilter.value === 'None' ? teamApp.status === '' : teamApp.status === docFilter.value
                }) : true;
        },

        filterByTeam(team) {
            return team.teamId ? team.teamId === this.filter.team.teamId : true
        },

        getRowClass(row, isObject) {
            const statusToCheck = isObject ? row.status : row
            const rowStatus = statusToCheck && !statusOptionsClasses[statusToCheck] ? 'status-nude' : statusOptionsClasses[statusToCheck]
            const rowClass = isObject ? `app-table__row ${rowStatus}` : `multiselect__tag status-tag ${rowStatus}`
            return {
                [rowClass]: true,

            }
        },
    },

};
</script>

<style>
.student-status-tl {
    padding: 8px 12px;
    border-radius: 8px;
    margin: 6px 0;
}

.team-filters {
    align-items: flex-start;
}

td[data-label='Application status'] {
    display: flex;
    flex-direction: column-reverse;
}

.student-status-tl.hide-student {
    display: none;
}

td[data-label='Application status'] a {
    color: black;
}

.content.user__content.tl__content {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
}

.student__advisor--card {
    display: inline-flex;
}

.collapse .tl__collapse.collpase-content {
    display: block;
}

.message-hide-close button.delete {
    display: none;
}

.multiselect__tag.status-tag,
.multiselect__tag.status-tag.status-nude {
    color: #363636;
}
</style>
